import React from 'react';
import { companyInfo } from '../data/mock';
import { MapPin, Phone } from 'lucide-react';

const ContactSection = () => {
  return (
    <section id="contacto" className="bg-black py-20 lg:py-28">
      {/* Top gold line */}
      <div className="gold-divider mb-20" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="text-3xl md:text-4xl font-semibold text-white mb-4">
            <span className="gold-text">Contacto</span>
          </h2>
          <div className="gold-divider w-32 mx-auto mt-8" />
        </div>

        {/* Contact Info */}
        <div className="max-w-2xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8">
            {/* Address */}
            <div className="border border-[#D4AF37]/30 p-8 text-center animate-fade-in-up">
              <div className="flex justify-center mb-4">
                <div className="w-12 h-12 flex items-center justify-center border border-[#D4AF37]/40 bg-[#D4AF37]/10">
                  <MapPin className="h-6 w-6 text-[#D4AF37]" />
                </div>
              </div>
              <h3 className="text-lg font-medium text-white mb-2">Dirección</h3>
              <a
                href="https://www.google.com/maps?q=240+Main+Street,+Danbury,+CT"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 hover:text-[#D4AF37] transition-colors"
              >
                {companyInfo.address}
              </a>
            </div>

            {/* Phones */}
            <div className="border border-[#D4AF37]/30 p-8 text-center animate-fade-in-up animate-delay-100">
              <div className="flex justify-center mb-4">
                <div className="w-12 h-12 flex items-center justify-center border border-[#D4AF37]/40 bg-[#D4AF37]/10">
                  <Phone className="h-6 w-6 text-[#D4AF37]" />
                </div>
              </div>
              <h3 className="text-lg font-medium text-white mb-2">Teléfonos</h3>
              <div className="space-y-1">
                <a
                  href={companyInfo.telLink1}
                  className="block text-[#D4AF37] hover:text-[#E8C554] transition-colors"
                >
                  {companyInfo.phone1}
                </a>
                <a
                  href={companyInfo.telLink2}
                  className="block text-[#D4AF37] hover:text-[#E8C554] transition-colors"
                >
                  {companyInfo.phone2}
                </a>
              </div>
            </div>
          </div>

          {/* Additional note */}
          <p className="text-center text-white/50 text-sm mt-8 animate-fade-in-up animate-delay-200">
            Visítanos o llámanos para una orientación rápida.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
